export default class AlgoliaAutocomplete {
  static createScriptsAndAppend() {
    const autocompleteScript = document.createElement('script');
    autocompleteScript.type = 'text/javascript';
    autocompleteScript.defer;
    autocompleteScript.src =
      'https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js';

    const popularSearchesScript = document.createElement('script');
    popularSearchesScript.type = 'text/javascript';
    autocompleteScript.defer;
    popularSearchesScript.src =
      'https://cdn.jsdelivr.net/npm/@algolia/autocomplete-plugin-query-suggestions@1.12.2/dist/umd/index.production.min.js';

    document.head.appendChild(autocompleteScript);
    document.head.appendChild(popularSearchesScript);
    return autocompleteScript;
  }
}
